module.exports = __webpack_public_path__ + "static/component_pouch-68bcea14faa304fd1fc86771b2ee507f.jpg";